import { Lookup } from '.'
import { LogAPI } from '../api'
import { messageErrorFormikLog } from './message'

export const insertLog = async ({
  message,
  action,
  refNo,
  module,
  submodule = '',
  errorLevel = Lookup.LOG_ERROR_LEVEL.ERROR,
  to = '',
  from = '',
  formInput,
  dbDestination = ''
}) => {
  try {
    const userInfo = JSON.parse(localStorage.getItem('user_info'))
    const detail =
      Object.entries(formInput.touched).length > 0
        ? messageErrorFormikLog(formInput.errors)
        : Lookup.LOG_MESSAGE.NO_INPUT

    const dataInsert = {
      To: to,
      From: from,
      Refno: refNo,
      Action: action,
      Module: module,
      Detail: formInput ? detail : message,
      Logtype: Lookup.LOG_TYPE.SYSTEM_LOG,
      Timestamp: new Date().toISOString(),
      Submodule: submodule,
      Errorlevel: errorLevel,
      db_destination: dbDestination,
      login: userInfo.User.Email
    }
    if (formInput) {
      if (
        Object.entries(formInput.touched).length === 0 || // Submit without touching fields
        Object.entries(formInput.errors).length > 0 // Submit with errors
      ) {
        const { data } = await LogAPI.PostDataLog(dataInsert)
        if (data && data.result) return data.result
      }
    } else {
      const { data } = await LogAPI.PostDataLog(dataInsert)
      if (data && data.result) return data.result
    }
    return false
  } catch (err) {
    return false
  }
}
